module.exports = __webpack_public_path__ + "static/img/indexicon2.b2abdb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/indexicon2.png
// module id = 9pLX
// module chunks = 1